import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { v4 as uuid } from 'uuid';

export interface IEidosDragDropSelector {
  attribute:string;
  match:'start'|'end'|'contains'|'equal'|'defined';
  value?:string;
}
export interface IEidosDragDrop {
  data:any;
  context?:any;
  dropSelectors:Array<string|IEidosDragDropSelector>;
  dragAction?: (event:any) => any;
  dropAction: (event:any, data:any, targetValue?:any) => void;
}
@Directive({
    selector: '[eidosDragDrop]',
    standalone: false
})
export class EidosDragDropDirective implements OnInit {
  /**
   * drag & drop configuration
   *
   * @type {string}
   * @memberof EidosDragDropDirective
   */
  @Input() eidosDragDrop:IEidosDragDrop;

  private sourceId:string;
  private targetId:string;
  private originalOpacity:string|undefined;
  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
  ) {
    this.eidosDragDrop={
      data:null,
      dropSelectors:[],
      dropAction:()=>{}
    };
    this.sourceId = uuid();
    this.targetId = uuid();
  }
  ngOnInit(): void {
    if(!this._elementRef.nativeElement) this._renderer.setAttribute(this._elementRef.nativeElement, 'id', this.sourceId);
    this._renderer.setAttribute(this._elementRef.nativeElement, 'draggable', 'true');
    this._renderer.addClass(this._elementRef.nativeElement, 'eidos-drag-source');
    this._renderer.listen(this._elementRef.nativeElement,'dragstart', this.handleDragStart.bind(this));
    this._renderer.listen(this._elementRef.nativeElement,'dragend', this.handleDragEnd.bind(this));
  }

  private calculateSelector(selector: string|IEidosDragDropSelector): string {
    if(typeof selector === 'string') return selector;

    const sel = selector as IEidosDragDropSelector;
    if(sel) {
      switch(sel.match) {
        case 'start':
          return `[${selector.attribute}^="${selector.value}"]`;
        case 'end':
          return `[${selector.attribute}$="${selector.value}"]`;
        case 'contains':
          return `[${selector.attribute}*="${selector.value}"]`;
        case 'equal':
          return `[${selector.attribute}="${selector.value}"]`;
        case 'defined':
        default:
          return `[${selector.attribute}]`;
      }
    }
    return '';
  }

  protected handleDragStart(event:any) {
    if(typeof this.eidosDragDrop.dragAction === 'function') {
      const actionData = this.eidosDragDrop.dragAction.bind(this.eidosDragDrop.context ?? this)(event);
      if(actionData) this.eidosDragDrop.data = actionData;
    }

    this.sourceId = event.currentTarget ?? this.sourceId;
    // let cache: any[] = []
    // const data = JSON.stringify( this.eidosDragDrop.data, (_key, value) => {
    //     if (typeof value === 'object' && value !== null) {
    //         if (cache.indexOf(value) !== -1) {
    //             // Circular reference found, discard key
    //             return
    //         }
    //         // Store value in our collection
    //         cache.push(value)
    //     }
    //     return value
    // }, '    ')
    // cache = [] // GC
    const data = JSON.stringify( this.eidosDragDrop.data )
    event
      .dataTransfer
      .setData('text/plain', data);

    event.dataTransfer.dropEffect  = "copy";

    this.originalOpacity = event.currentTarget
                                .style
                                .opacity;

    event
      .currentTarget
      .style
      .opacity = '0.4';

    if(event.dataTransfer) event.dataTransfer.effectAllowed='copy';

    const self = this;
    this.eidosDragDrop
      .dropSelectors
      .forEach(s=>{
        let selector = this.calculateSelector(s);
        if(selector === '') return;
        document.querySelectorAll(selector)
          .forEach(function (item) {
            self._renderer.addClass(item,'eidos-drag-target');
            self._renderer.listen(item,'dragover', self.handleDragOver.bind(self));
            self._renderer.listen(item,'dragenter', self.handleDragEnter.bind(self));
            self._renderer.listen(item,'dragleave', self.handleDragLeave.bind(self));
            self._renderer.listen(item,'drop', self.handleDrop.bind(self));
          });
      });
  }

  protected handleDragOver(event:any) {
    event.preventDefault();
  }
  protected handleDragEnter(event:any) {
    event.preventDefault();
    // if(event.dataTransfer) {
    //   const img = new Image();
    //   img.src = "assets/images/okdrop.png";
    //   event.dataTransfer.setDragImage(img, 30, 30);
    // }

    //if(event.target) event.target.style = `cursor: url('assets/images/okdrop.png') 25 15, move !important;`;
    //if(event.relatedTarget) this._renderer.addClass(event.relatedTarget,'eidos-drag-valid');
    //if(event.currentTarget) this._renderer.addClass(event.currentTarget,'eidos-drag-valid');
  }
  protected handleDragLeave(event:any) {
    event.preventDefault();
    // if(event.dataTransfer) {
    //   const img = new Image();
    //   event.dataTransfer.setDragImage(img, 30, 30);
    // }
    //if(event.target) event.target.style = "";
    //if(event.relatedTarget) this._renderer.removeClass(event.relatedTarget,'eidos-drag-valid');
    //if(event.currentTarget) this._renderer.removeClass(event.currentTarget,'eidos-drag-valid');

  }
  protected handleDragEnd(event:any) {
    event
    .currentTarget
    .style
    .opacity = this.originalOpacity;

    // this._renderer.removeClass(event.currentTarget,'eidos-drag-valid');
    // this._renderer.removeClass(event.target,'eidos-drag-valid');

    const self = this;
    this.eidosDragDrop
    .dropSelectors
    .forEach(s=>{
      let selector = this.calculateSelector(s);
      if(selector === '') return;

      document.querySelectorAll(selector)
        .forEach(function (item) {
          self._renderer.removeClass(item,'eidos-drag-target');
          item.removeEventListener('dragover', self.handleDragOver);
          item.removeEventListener('dragenter', self.handleDragEnter);
          item.removeEventListener('dragleave', self.handleDragLeave);
          item.removeEventListener('drop', self.handleDrop);
        });
    });
  }
  protected handleDrop(event:any) {
    event.preventDefault();
    this.targetId = event.currentTarget ?? this.targetId;

    //Retrive traget value if defined
    let targetValue;
    try {
      let el:HTMLElement|null = event.target as HTMLElement;
      targetValue =el?.getAttribute('data-eidos-target-value');
      while(el !== null  && !targetValue) {
        el = el?.parentElement ?? null;
        targetValue = el?.getAttribute('data-eidos-target-value');
      }
    } catch {
      targetValue=null;
    }

    try {
      const data = JSON.parse(
        event
        .dataTransfer
        .getData('text')
      );
      data.targetId = this.targetId;
      this.eidosDragDrop.dropAction.bind(this.eidosDragDrop.context ?? this)(event,data,targetValue);
    } catch(error) {
      this.eidosDragDrop.dropAction.bind(this.eidosDragDrop.context ?? this)(event,{});
    }
  }

}
